export const Environments = {
    Production: 'Production',
    Staging: 'Staging',
    QualityAssurance: 'Quality Assurance',
    Development: 'Development',
    Demonstration: 'Demonstration',
    Sandbox: "Sandbox"
  }